import { useState } from "react";
import type { ThinkingBlock } from "@/lib/chat-types";

function StepIcon({ icon }: { icon: string }) {
  if (icon === "visit")
    return (
      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10" /><path d="M2 12h20" /><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10Z" />
      </svg>
    );
  if (icon === "analyze")
    return (
      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <line x1="18" y1="20" x2="18" y2="10" /><line x1="12" y1="20" x2="12" y2="4" /><line x1="6" y1="20" x2="6" y2="14" />
      </svg>
    );
  return (
    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="11" cy="11" r="8" /><line x1="21" y1="21" x2="16.65" y2="16.65" />
    </svg>
  );
}

export function ThinkingCard({ thinking }: { thinking: ThinkingBlock }) {
  const [open, setOpen] = useState(false);

  return (
    <div className="border border-[var(--color-border)] rounded-[10px] overflow-hidden my-2">
      <button
        onClick={() => setOpen((v) => !v)}
        className="flex items-center gap-2.5 w-full px-3.5 py-2.5 text-left text-[13px] font-medium text-[var(--color-fg)] cursor-pointer"
        style={{ fontFamily: "var(--font-display)" }}
      >
        <span className="w-5 h-5 rounded-full bg-[var(--color-accent)] flex items-center justify-center shrink-0">
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="20 6 9 17 4 12" />
          </svg>
        </span>
        <span className="flex-1">{thinking.title}</span>
        <svg
          width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"
          className="text-[var(--color-fg-tertiary)]"
          style={{ transform: open ? "rotate(90deg)" : "rotate(0deg)", transition: "transform 150ms" }}
        >
          <polyline points="9 18 15 12 9 6" />
        </svg>
      </button>
      {open && (
        <div className="px-3.5 pb-3 border-t border-[var(--color-border)]">
          <p className="text-xs leading-relaxed text-[var(--color-fg-secondary)] mt-2.5 mb-2">{thinking.description}</p>
          <div className="flex flex-col gap-1">
            {thinking.steps.map((step, i) => (
              <div key={i} className="flex items-center gap-2 px-2.5 py-1.5 rounded-md bg-[var(--color-border)]/30 text-xs text-[var(--color-fg-secondary)]">
                <span className="shrink-0 opacity-60"><StepIcon icon={step.icon} /></span>
                {step.text}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
